import { render, staticRenderFns } from "./_cardView.vue?vue&type=template&id=62e7cca6&scoped=true"
import script from "./_cardView.vue?vue&type=script&lang=js"
export * from "./_cardView.vue?vue&type=script&lang=js"
import style0 from "./_cardView.vue?vue&type=style&index=0&id=62e7cca6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62e7cca6",
  null
  
)

export default component.exports